import {gql} from "@apollo/client";

export const CORE_OBLIGATION_TYPE_FIELDS = gql`
  fragment CoreObligationTypeFields on ObligationType {
    id
    name
    description
    isDeleted
    backgroundColor
    foregroundColor
  }
`;

export const GET_OBLIGATION_TYPES = gql`
  ${CORE_OBLIGATION_TYPE_FIELDS}
  query GetObligationTypes {
    obligationTypes(orderBy: {name: asc}) {
      ...CoreObligationTypeFields
      conditions {
        condition {
          id
          field
        }
      }
      inUseBy {
        model
        count
      }
    }
  }
`;
export const CREATE_OBLIGATION_TYPE = gql`
  ${CORE_OBLIGATION_TYPE_FIELDS}
  mutation CreateObligationType(
    $name: String!
    $description: String
    $backgroundColor: String
    $foregroundColor: String
  ) {
    createOneObligationType(
      data: {
        name: $name
        description: $description
        backgroundColor: $backgroundColor
        foregroundColor: $foregroundColor
      }
    ) {
      ...CoreObligationTypeFields
    }
  }
`;
export const UPDATE_OBLIGATION_TYPE = gql`
  ${CORE_OBLIGATION_TYPE_FIELDS}
  mutation UpdateObligationType(
    $id: Int!
    $name: String!
    $description: String
    $backgroundColor: String
    $foregroundColor: String
  ) {
    updateOneObligationType(
      where: {id: $id}
      data: {
        name: {set: $name}
        description: {set: $description}
        backgroundColor: {set: $backgroundColor}
        foregroundColor: {set: $foregroundColor}
      }
    ) {
      ...CoreObligationTypeFields
    }
  }
`;
export const SOFT_DELETE_OBLIGATION_TYPE = gql`
  ${CORE_OBLIGATION_TYPE_FIELDS}
  mutation SoftDeleteObligationType($id: Int!) {
    deleteOneObligationType(where: {id: $id}) {
      ...CoreObligationTypeFields
    }
  }
`;
